import PatientProject from './PatientProject';

export default PatientProject;
